import {
    getPlaybook,
    listPlaybooks
} from './queries';
import {
    createPlaybook,
    deletePlaybook,
    updatePlaybook,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreatePlaybook,
    DeletePlaybook,
    GetPlaybook,
    ListPlaybooks,
    Playbook,
    UpdatePlaybook
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListPlaybooks>>({
                                                                           query: listPlaybooks,
                                                                           variables: {
                                                                               filter: filter
                                                                           },
                                                                       });
    return response.data?.listPlaybooks.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPlaybook>>({
                                                                         query: getPlaybook,
                                                                         variables: {id: id},
                                                                     });
    return response.data?.getPlaybook;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreatePlaybook>>({
                                                                            query: createPlaybook,
                                                                            variables: {input: payload},
                                                                        });
    return response.data?.createPlaybook;
};

export const update = async (_id: string, record: Playbook) => {

    delete record.created;
    delete record.updated;
    delete record.createdByUsername

    const response = await client.graphql<GraphQLQuery<UpdatePlaybook>>({
                                                                            query: (updatePlaybook),
                                                                            variables: {input: record},
                                                                        });
    return response.data?.updatePlaybook;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePlaybook>>({
                                                                            query: (deletePlaybook),
                                                                            variables: {input: {id: id}},
                                                                        });
    return response.data?.deletePlaybook;
};
